import React from 'react';
import { Box, Typography, Button, Tooltip } from '@mui/material';
import { layout } from '../../themes/smartinventoryTheme';

// Two distinct kinds — never one generic "no data":
//   kind="none"      nothing created yet: icon, teaches, offers the primary action.
//   kind="no-match"  a search/filter found nothing: repeats the query and the
//                     active filters (caller supplies them via title/description)
//                     and offers a way out (actions).
// All copy and action labels are passed in already translated. An action may
// carry `disabled`/`disabledReason` (same shape as PageHeader.actions) — used
// at a plan limit (step 9): the button stays visible, disabled, with a tooltip.
const EmptyState = ({ kind = 'none', icon: Icon, title, description, actions = [] }) => (
  <Box sx={{ textAlign: 'center', py: kind === 'none' ? 5 : 3, px: 3 }}>
    {kind === 'none' && Icon && (
      <Box
        sx={{
          width: layout.stateIconSize,
          height: layout.stateIconSize,
          borderRadius: '50%',
          bgcolor: 'primary.light',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          mb: 1.5,
        }}
      >
        <Icon color="primary" />
      </Box>
    )}
    <Typography variant={kind === 'none' ? 'subtitle1' : 'h6'}>{title}</Typography>
    {description && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, maxWidth: 380, mx: 'auto' }}>
        {description}
      </Typography>
    )}
    {actions.length > 0 && (
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center', mt: 2, flexWrap: 'wrap' }}>
        {actions.map((action) => {
          const button = (
            <Button
              variant={action.variant || 'outlined'}
              size={kind === 'none' ? 'medium' : 'small'}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.label}
            </Button>
          );
          return action.disabled && action.disabledReason ? (
            <Tooltip key={action.label} title={action.disabledReason}>
              <span>{button}</span>
            </Tooltip>
          ) : (
            <React.Fragment key={action.label}>{button}</React.Fragment>
          );
        })}
      </Box>
    )}
  </Box>
);

export default EmptyState;
